
/**
 * Module dependencies.
 */

import { Box } from 'react-components/layout';
import { hslColor } from './styles/colors';
import { ifProp } from 'styled-tools';
import styled, { css } from 'styled-components';

/**
 * Export `Divider` styled component.
 */

export const Divider = styled(Box)<{ vertical?: boolean }>`
  background-color: ${hslColor('gray400', 90)};
  height: 1px;
  width: 100%;

  ${ifProp('vertical', css`
    height: 100%;
    width: 1px;
  `)}
`;
